import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

import * as AuthService from 'services/auth.service'

const SedeFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  const [sedes, setsedes] = React.useState([])

  React.useEffect(() => {
    AuthService.getSedesHabilitadas().then(({ data }) => {
      setsedes(data)
    })
  }, [])

  return (
    <Form.Group>
      <Form.Label text='Establecimiento' md={4} alignRightAt='md' />
      <Col md={8}>
        <Field name='_idSede'>
          {({ field }) => (
            <Form.Select
              {...field}
              id='select-sede'
              isInvalid={iError && iTouched}
              disabled={fIsSubmitting}
            >
              <option value=''>Seleccionar</option>
              {sedes.map(x => (
                <option key={x._id} value={x._id}>
                  {x.nombre}
                </option>
              ))}
            </Form.Select>
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(SedeFormGroup)
